import ConfirmationModal from 'components/organisms/confirmation-modal';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ThirdpartyUnlinkModalProps } from './types';
import { useFetch } from 'hooks';
import { useAuth } from 'auth';
import { useConfig } from 'config';
import { useTerminologyConfig } from 'context/DataContext';

const ThirdpartyUnlinkModal: React.FC<ThirdpartyUnlinkModalProps> = ({
  isOpen,
  onClose,
  onUnlinked,
  linkThirdParty,
  parentThirdPartyId,
}) => {
  const { tokenInfo } = useAuth();
  const { vantageWebApi } = useConfig();
  const terminologyConfig = useTerminologyConfig();
  const [loadingStatus, setLoadingStatus] = useState<string>('not started');
  const [title, setTitle] = useState<string>(
    `Unlink a ${terminologyConfig?.thirdPartySingularNaming}?`
  );
  const [message, setMessage] = useState<string>('');
  const history = useHistory();

  const { loading, trigger: triggerUnlink } = useFetch(
    `${vantageWebApi}/thirdParty/${parentThirdPartyId}/link/${linkThirdParty?.id}`,
    {
      method: 'DELETE',
      lazy: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenInfo.accessToken}`,
      },
    }
  );

  useEffect(() => {
    if (linkThirdParty) {
      setMessage(
        `Are you sure you want to unlink this ${terminologyConfig?.thirdPartySingularNaming}? This action cannot be undone.`
      );
    }
    // eslint-disable-next-line
  }, [linkThirdParty, parentThirdPartyId]);

  useEffect(() => {
    if (loading) {
      setLoadingStatus('started');
      setTitle('Unlinking, please wait');
    }
    if (!loading && loadingStatus === 'started') {
      setLoadingStatus('completed');
    }
    if (loadingStatus === 'completed') {
      setLoadingStatus('not started');
      setTitle('Unlinked, reloading page');
      setMessage('');
      if (onUnlinked) {
        onUnlinked();
      }
      onClose();
    }
    // eslint-disable-next-line
  }, [loading, loadingStatus, history]);

  const handleProceed = (): void => {
    if (linkThirdParty?.id == null || parentThirdPartyId == null) {
      return;
    }
    triggerUnlink();
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      title={title}
      onProceed={handleProceed}
      message={message}
      loading={loading}
    ></ConfirmationModal>
  );
};

export default ThirdpartyUnlinkModal;
